import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TabGroupBaseDirective } from './tab-group-base.directive';
import { TabGroupComponent } from './tab-group.component';
import { TabComponent } from '../tab.component';
import { SectionComponent } from '../../section/section.component';


@Component({
    selector: 'sirius-tab-group-dynamic',
    template: `
        @if (config) {
            <sirius-tab-group [size]="config.size ?? 'large'">
                @for (tab of config.tabs; track $index) {
                    <sirius-tab [active]="$index === currentIndex" [title]="tab.title">
                        @for (section of tab.body; track $index) {
                            <sirius-section [config]="section"> </sirius-section>
                        }
                    </sirius-tab>
                }
            </sirius-tab-group>
        }
    `,
    styles: ':host { width: 100%; }',
    imports: [TabGroupComponent, TabComponent, SectionComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabGroupDynamicComponent extends TabGroupBaseDirective {}
